export const OilIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
    >
      <path
        d="M1.12968 10.803C1.12968 10.4997 1.37558 10.2538 1.67892 10.2538H12.6638C12.9671 10.2538 13.213 10.4997 13.213 10.803V12.4508C13.213 12.7541 12.9671 13 12.6638 13H1.67892C1.37559 13 1.12968 12.7541 1.12968 12.4508V10.803Z"
        stroke="#18181B"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M2.77741 5.3106H5.52363V10.2538H2.77741V5.3106Z"
        stroke="#18181B"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M8.81908 5.3106H11.5653V10.2538H8.81908V5.3106Z"
        stroke="#18181B"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
      <path
        d="M1.55016 5.3106C0.986933 5.3106 0.788642 4.56392 1.27766 4.28448L6.89885 1.07237C7.06771 0.975878 7.275 0.975878 7.44386 1.07237L13.065 4.28448C13.5541 4.56392 13.3558 5.3106 12.7925 5.3106H1.55016Z"
        stroke="#18181B"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  );
};
